export function megaMenu() {
	document.addEventListener('DOMContentLoaded', function () {
		const megaMenus = document.querySelectorAll('[data-mega-menu]')

		megaMenus.forEach(megaMenu => {
			const megaMenuLinks = megaMenu.querySelectorAll('[data-mega-menu-link-hover]')
			const detailItems = megaMenu.querySelectorAll('[data-mega-menu-featured-link]')

			megaMenuLinks.forEach(link => {
				link.addEventListener('mouseenter', function () {
					const targetIndex = this.getAttribute('data-mega-menu-link-hover')

					megaMenuLinks.forEach(item => item.classList.remove('active'))
					detailItems.forEach(item => item.classList.remove('active'))

					this.classList.add('active')

					const targetDetail = megaMenu.querySelector(`[data-mega-menu-featured-link="${targetIndex}"]`)
					if (targetDetail) {
						targetDetail.classList.add('active')
					}
				})
			})
		})
	})
}